"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkable;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _useChecked2 = require("../hooks/useChecked");

var _utils = require("./utils");

/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox/radio inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * @param {JSX.Component} Component
 * @returns {JSX.Component} A component with defaultable `checked` prop
 */
function Checkable(Component) {
  var CheckableComponent = (0, _react.forwardRef)(function (props, ref) {
    var __checked = props.checked,
        __defaultChecked = props.defaultChecked,
        __onChange = props.onChange,
        rest = (0, _objectWithoutProperties2.default)(props, ["checked", "defaultChecked", "onChange"]); // eslint-disable-next-line react-hooks/rules-of-hooks

    var _useChecked = (0, _useChecked2.useChecked)(props),
        checked = _useChecked.checked,
        onChange = _useChecked.onChange;

    return _react.default.createElement(Component, Object.assign({}, rest, {
      checked: checked,
      onChange: onChange,
      ref: ref
    }));
  });
  CheckableComponent.propTypes = Object.assign({}, Component.propTypes, {}, _useChecked2.checkedPropTypes);
  CheckableComponent.defaultProps = Object.assign({}, Component.defaultProps, {
    defaultChecked: Component.defaultProps && Component.defaultProps.checked != null ? Component.defaultProps.checked : false
  });
  delete CheckableComponent.defaultProps.checked;
  CheckableComponent.displayName = "Checkable(" + (0, _getComponentName.default)(Component) + ")";
  (0, _utils.attachWrappedComponent)(CheckableComponent, Component);
  return CheckableComponent;
}

module.exports = exports.default;